module.exports = __webpack_public_path__ + "img/swiper1-2.e03dc0a0.png";